export enum AppLaunchError {
  AadStateInvalid = "aadstateinvalid",
  AccessTokenInvalid = "accesstokeninvalid",
  AppointmentNotFound = "appointmentnotfound",
  AuthStateInvalid = "authstateinvalid",
  CannotAcquireAccessToken = "cannotacquireaccesstoken",
  CannotCreateMeeting = "cannotcreatemeeting",
  CannotStampEhrExtension = "aannotstampehrextension",
  EncounterHasMultipleAppointmentReferences = "encounterhasmultipleappointmentreferences",
  EncounterHasNoAppointmentReference = "encounterhasnoappointmentreference",
  InvalidUrlParams = "invalidurlparams",
  IssuerUrlInvalid = "issuerurlinvalid",
  Licensenotfound = "licensenotfound",
  NoTenantConfigsConfigured = "notenantconfigsconfigured",
  NotVirtualVisit = "notvirtualvisit",
  PageNotFound = "pagenotfound",
  PatientInactive = "patientinactive",
  SessionExpired = "sessionexpired",
  SubjectNotPatient = "subjectnotpatient",
  TenantConfigNotFound = "tenantconfignotfound",
  TenantSuspended = "tenantsuspended",
  UnAuthenticated = "unauthenticated",
  UnAuthorized = "unauthorized",
  UserConfigNotFound = "userconfignotfound",
}
